import {useQuery} from 'react-query';
import {getBuyerPhoneNumber} from 'services/buyers/phoneNumber';

const useGetWantedPhoneNumber = (
  postId: string,
  inputGroupId: string | undefined,
) => {
  const {
    data: phoneNumber,
    isLoading: isGetPhoneNumberLoading,
    refetch,
  } = useQuery(
    ['getPhoneWantedPhoneNumber', inputGroupId, postId],
    getBuyerPhoneNumber,
    {
      enabled: false,
      onSuccess: (data: IWantedPhoneNumber) => {
        window.open(`tel:${data.phone_number}`, '_self');
      },
    },
  );
  return {phoneNumber, isGetPhoneNumberLoading, refetch};
};

export default useGetWantedPhoneNumber;
